import { fetch, save, find, destroy } from '@/api/addresses'
import Vue from 'vue'

export default {
  state: {
    data: [],
    pagination: {}
  },

  mutations: {
    SET_ADDRESSES: (state, addresses) => {
      state.data = addresses.data
      state.pagination = addresses.pagination
    },

    ADD_ADDRESS: (state, item) => {
      state.data.push(item)
    },

    SET_CURRENT: (state, item) => {
      state.currentItem = item
    },

    UPDATE_ADDRESS: (state, itemP) => {
      console.log();
      let exist = false
      state.data.map((item, index) => {
        if (item.id == itemP.id) {
          // state.data[index] = itemP
          Vue.set(state.data, index, itemP);
          exist = true
          return
        }

      })
      if (!exist) {
        state.data.push(itemP)

      }

      if (state.currentItem && state.currentItem.id === itemP.id) {
        state.currentItem = itemP
      }
    },

    REMOVE_ADDRESS: (state, id) => {
      state.data = state.data.filter(item => item.id !== id)

      if (state.currentItem && state.currentItem.id === id) {
        state.currentItem = {}
      }
    }

  },
  actions: {
    fetchAddresses({ commit }, queryParams) {
      return new Promise((resolve, reject) => {
        fetch(queryParams)
          .then(({ data }) => {
            commit('SET_ADDRESSES', data)
            resolve(data)
          })
          .catch(e => reject(e))
      })
    },

    findAddress({ commit }, id) {
      return new Promise((resolve, reject) => {
        find(id)
          .then(({ data }) => {
            commit('SET_CURRENT', data)
            resolve()
          })
          .catch(error => reject(error))
      })
    },

    saveAddress({ commit }, request) {
      return new Promise((resolve, reject) => {
        save(request)
          .then(({ data }) => {
            commit('UPDATE_ADDRESS', data)
            commit('SET_CURRENT', data)
            resolve()
          })
          .catch(error => reject(error))
      })
    },

    destroyAddress({ commit }, id) {
      return new Promise((resolve, reject) => {
        destroy(id)
          .then(() => {
            commit('REMOVE_ADDRESS', id)
            resolve()
          })
          .catch(error => reject(error))
      })
    }
  }
}
